import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const purchaseLoadCompleteInventoryAtom = createMutationAtomFactory(
  'trade.purchaseLoadCompleteInventory',
  (params: { id: string }) => ({
    tradePurchaseLoadCompleteInventory: {
      __args: {
        id: params.id,
      },
      id: true,
      status: true,
    },
  }),
);
